import * as React from "react";

import { Block } from "kanopi-components/Block";
import { BlockProps } from "baseui/block";
import { LabelSmall } from "kanopi-components/typography";
import { SIZE } from "kanopi-components/Button";
import { StringDisplay } from "./StringDisplay";
import { WidthContainer } from "../ChatFlow";
import { displayRegistry } from "./displayRegistry";
import { useStyletron } from "kanopi-components/theme/useStyletron";

type TFormListDisplay = {
  size?: SIZE;
  answer: string | number | undefined;
  question?: TQuestion;
} & BlockProps;

export const FormListDisplay: React.FC<TFormListDisplay> = ({
  size = SIZE.default,
  answer,
  question,
  ...restProps
}) => {
  const [css, theme] = useStyletron();
  return (
    <WidthContainer size={size}>
      {(answer || []).map((item) => (
        <Block
          key={JSON.stringify(item)}
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          justifyContent="center"
          paddingTop="scale400"
          paddingBottom="scale400"
          width="100%"
          overrides={{
            Block: {
              style: {
                ":not(:last-of-type)": {
                  borderBottom: "1px solid lightgrey",
                },
              },
              // props: {
              //   "data-testid": `listDisplay-${toCamelCase(item[newLabelAccessor])}`,
              // },
            },
          }}
        >
          <table>
            <tbody>
              {(question.inputArgs.displayFields ?? []).map((field, idx) => {
                const DisplayComponent = displayRegistry.getByType(
                  field.inputType,
                  StringDisplay
                );
                return (
                  <tr key={`table-row-${idx}`}>
                    <td
                      className={css({
                        width: "50%",
                        paddingRight: theme.sizing.scale800,
                        textAlign: "right",
                      })}
                    >
                      <LabelSmall>{field.label}</LabelSmall>
                    </td>
                    <td
                      className={css({
                        width: "50%",
                        fontSize: theme.typography.LabelSmall.fontSize,
                      })}
                    >
                      <DisplayComponent answer={item[field.valueAccessor]} />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </Block>
      ))}
    </WidthContainer>
  );
};
